import NumberInput from '../inputs/NumberInput';
import createField from './createField';

const NumberField = createField(NumberInput);

export default NumberField;
